import { CountriesProvider } from "./contexts/countriescontexts";

import "./App.css";

//import page
import Main from "./main/Main";
//import page
function App() {
  return (
    <CountriesProvider>
      <div className="App" style={{ display: "flex", height: "80vh" }}>
        <Main></Main>
      </div>
    </CountriesProvider>
  );
}

export default App;
